import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import FontAwesomeIcon from './FontAwesomeIcon';
import ClientProvider from './client';
export default createDemo(import.meta.url, FontAwesomeIcon, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/icons/demos/font-awesome/FontAwesomeIcon.tsx",
    "fileName": "FontAwesomeIcon.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport { loadCSS } from 'fg-loadcss';\nimport Stack from '@mui/material/Stack';\nimport { green } from '@mui/material/colors';\nimport Icon from '@mui/material/Icon';\n\nexport default function FontAwesomeIcon() {\n  React.useEffect(() => {\n    const href = 'https://use.fontawesome.com/releases/v5.14.0/css/all.css';\n    if (document.querySelector(`link[href=\"${href}\"]`)) {\n      return undefined;\n    }\n\n    const node = loadCSS(\n      href,\n      // Inject before JSS\n      (document.querySelector('#font-awesome-css') ||\n        document.head.firstChild) as HTMLElement,\n    );\n\n    return () => {\n      node.parentNode!.removeChild(node);\n    };\n  }, []);\n\n  return (\n    <Stack direction=\"row\" spacing={4} sx={{ alignItems: 'flex-end' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Icon baseClassName=\"fas\" className=\"fa-plus-circle\" />\n      <Icon baseClassName=\"fas\" className=\"fa-plus-circle\" color=\"primary\" />\n      <Icon\n        baseClassName=\"fas\"\n        className=\"fa-plus-circle\"\n        sx={{ color: green[500] }}\n      />\n      <Icon baseClassName=\"fas\" className=\"fa-plus-circle\" fontSize=\"small\" />\n      <Icon baseClassName=\"fas\" className=\"fa-plus-circle\" sx={{ fontSize: 30 }} />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 39,
        "focusedLines": 9,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport { loadCSS } from 'fg-loadcss';\nimport Stack from '@mui/material/Stack';\nimport { green } from '@mui/material/colors';\nimport Icon from '@mui/material/Icon';\n\nexport default function FontAwesomeIcon() {\n  React.useEffect(() => {\n    const href = 'https://use.fontawesome.com/releases/v5.14.0/css/all.css';\n    if (document.querySelector(`link[href=\"${href}\"]`)) {\n      return undefined;\n    }\n\n    const node = loadCSS(\n      href,\n      // Inject before JSS\n      (document.querySelector('#font-awesome-css') ||\n        document.head.firstChild) as HTMLElement,\n    );\n\n    return () => {\n      node.parentNode!.removeChild(node);\n    };\n  }, []);\n\n  return (\n    <Stack direction=\"row\" spacing={4} sx={{ alignItems: 'flex-end' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Icon baseClassName=\"fas\" className=\"fa-plus-circle\" />\n      <Icon baseClassName=\"fas\" className=\"fa-plus-circle\" color=\"primary\" />\n      <Icon\n        baseClassName=\"fas\"\n        className=\"fa-plus-circle\"\n        sx={{ color: green[500] }}\n      />\n      <Icon baseClassName=\"fas\" className=\"fa-plus-circle\" fontSize=\"small\" />\n      <Icon baseClassName=\"fas\" className=\"fa-plus-circle\" sx={{ fontSize: 30 }} />\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 28
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Icon"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "baseClassName"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "fas",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "className"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "fa-plus-circle",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 29
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Icon"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "baseClassName"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "fas",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "className"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "fa-plus-circle",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "primary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 30
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Icon"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 31
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "baseClassName"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "fas",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 32
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "className"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "fa-plus-circle",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 33
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "color"
              ],
              ": ",
              [
                "span",
                "pl-smi di-jv",
                "green"
              ],
              "[",
              [
                "span",
                "pl-c1 di-num",
                "500"
              ],
              "] }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 34
            },
            "      />"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 35
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Icon"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "baseClassName"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "fas",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "className"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "fa-plus-circle",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "fontSize"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "small",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 36
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Icon"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "baseClassName"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "fas",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "className"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "fa-plus-circle",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "fontSize"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "30"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 39,
    "focusedLines": 9,
    "collapsible": true,
    "externals": [
      "react",
      "fg-loadcss",
      "@mui/material/Stack",
      "@mui/material/colors",
      "@mui/material/Icon"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
